import React from 'react';

const WideRangeSection = () => {
  return (
    <div className="section-full p-t150 p-b120 site-bg-white twm-w-range-section-wrap wow fadeInDown p-0" data-wow-offset="100" data-wow-delay="0.2">
      <div className="container">
        {/* TITLE START */}
        <div className="section-head center">
          <div className="twm-sm-title left">Find your cab</div>
          <h2 className="twm-large-title site-text-dark">
            Wide Range Of Commercial
            <br />
            And Luxury Cars
          </h2>
        </div>
        {/* TITLE END */}

        <div className="section-content">
          <div className="row twm-w-range-section">
            {/* One block */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="twm-cntr-with-icon">
                <div className="icon-media">
                  <img src="images/icons/rental.png" alt="" />
                </div>
                <span className="counter">5000 </span> <em className="symble">+</em>
                <h3 className="icon-content-info">Client Served</h3>
              </div>
            </div>

            {/* Two block */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="twm-cntr-with-icon">
                <div className="icon-media">
                  <img src="images/icons/man.png" alt="" />
                </div>
                <span className="counter">4000 </span> <em className="symble">+</em>
                <h3 className="icon-content-info">Happy Customers</h3>
              </div>
            </div>

            {/* Three block */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="twm-cntr-with-icon">
                <div className="icon-media">
                  <img src="images/icons/car-insurance.png" alt="" />
                </div>
                <span className="counter">100</span> <em className="symble">+</em>
                <h3 className="icon-content-info"> Vehicle Fleet</h3>
              </div>
            </div>

            {/* Four block */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="twm-cntr-with-icon">
                <div className="icon-media">
                  <img src="images/icons/work-time.png" alt="" />
                </div>
                <span className="counter">5</span> <em className="symble">+</em>
                <h3 className="icon-content-info">Years Experience</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WideRangeSection;
